import { presale_abi, usdt_abi } from "../abi/abi";

//contracy Address
const USDTAddress = "0xdAC17F958D2ee523a2206206994597C13D831ec7";
const PreSaleAddress = "0x58eba732dFdecc297ab1d5BCe2cB4cE691d2EbFe";
const TokenAddress = "0x26431f855b1e8C7F4ab1851a7A09AaB72d76252d";

const PreSaleWagamiContract = { address: PreSaleAddress, abi: presale_abi };
const USDTWagamiContract = { address: USDTAddress, abi: usdt_abi };

export {
  PreSaleAddress,
  PreSaleWagamiContract,
  USDTWagamiContract,
  TokenAddress,
};
